import { memo } from 'react';
import classNames from 'classnames';

import { NAVBAR_LINKS } from '../../../data/nav';
import { ALL_TOOLS } from '../../../data/tools';
import { Analytics } from '../../../services/analytics';
import { SingleToolLogo } from '../SingleToolLogo';
import { INavSubLink } from '../SingleToolNavigation';
import SingleToolNavigation from '../SingleToolNavigation/SingleToolNavigation';
import ShareButton from '../Widgets/ShareButton';
import { SingleToolSearch } from '../SingleToolSearch';

import useStyles from './style';

interface ISingleToolHeader {
  className?: string;
  goToLink?: (link: INavSubLink) => void;
  noBorder?: boolean;
  toolName?: string;
  pageName?: string;
  shareName?: string;
  analytics?: Analytics;
  widgetUrl?: string;
}

function SingleToolHeader({
  className,
  noBorder,
  analytics,
  toolName,
  pageName,
  shareName,
  widgetUrl,
}: ISingleToolHeader) {
  const classes = useStyles({ noBorder });

  const shareButtonToolName = shareName ?? ALL_TOOLS.filter((tool) => tool.id == toolName)[0]?.name;
  return (
    <header className={classNames(classes.root, className)}>
      <div className={classes.container}>
        <div className={classes.navContainer}>
          <SingleToolLogo className={classes.logo} href="/" />
          <SingleToolNavigation
            items={NAVBAR_LINKS}
            analytics={analytics}
            toolName={toolName}
            pageName={pageName}
          />
        </div>
        <div className={classes.buttonsContainer}>
          <SingleToolSearch
            analytics={analytics}
            className={classes.search}
            toolName={toolName}
            pageName={pageName}
            collabsable
          />
          <ShareButton
            analytics={analytics}
            toolName={shareButtonToolName ?? toolName}
            className={classes.shareButton}
            widgetUrl={widgetUrl}
          />
        </div>
      </div>
    </header>
  );
}

export default memo(SingleToolHeader);
